import { useCallback, useContext } from 'react';

import { LayoutActionType } from '../constant';
import { LayoutContext } from '..';

export default function useTradePanelLayout() {
  const context = useContext(LayoutContext);

  const dispatch = context?.dispatch || (() => {});
  const tradePanelShow = context?.layout?.tradePanelShow;

  return {
    show: useCallback(() => {
      dispatch({ type: LayoutActionType.TRADE_PANEL_SHOW });
    }, [dispatch]),

    hide: useCallback(() => {
      dispatch({ type: LayoutActionType.TRADE_PANEL_HIDE });
    }, [dispatch]),

    /** @type {bool} */
    isVisible: tradePanelShow,
  };
}
